var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bind-channel" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.initInfo.title,
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.initInfo.tips
            ? _c("el-alert", {
                attrs: {
                  title: _vm.initInfo.tips,
                  type: "warning",
                  "how-icon": "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", display: "flex" } },
            [
              _c("div", [_vm._v("上传文件：")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "ButtonUploadExcel",
                    {
                      attrs: {
                        beforeUpload: function (file) {
                          return _vm.beforeUpload(file)
                        },
                      },
                    },
                    [_vm._v("上传文件")]
                  ),
                  _vm._v(" "),
                  _vm.importFile && _vm.importFile.name
                    ? _c("div", { staticStyle: { "margin-top": "10px" } }, [
                        _vm._v("当前文件：" + _vm._s(_vm.importFile.name)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tips",
                      staticStyle: { "margin-top": "10px" },
                    },
                    [_vm._v("支持格式：.xls .xlsx .csv")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }